import React, { useEffect } from 'react';
import { Grid, Typography, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import styles from './styles';
import { Option, isIOS } from '../../../../../../../../components/Option';
import { MEASUREMENT_UNITS, MEASURE_UNITS_BY_SYSTEM } from 'common/measurements';

const homepageStatisticOptions = [
  { name: 'Liquid Marking', type: 'liquidMarking' },
  { name: 'Eradication', type: 'eradication' },
]

const UnitsType = ({ data, errors, classes, values, touched, handleChange, handleBlur, setFieldValue }) => {
  const [unitType, setUnitType] = React.useState(data?.type || values?.type)

  const materials = React.useMemo(() => ([
    {
      name: `Volume (${MEASURE_UNITS_BY_SYSTEM[values?.measurement][MEASUREMENT_UNITS.lengthPerVolume]})`,
      type: 'volume',
      designation: 'liquidMarking'
    },
    {
      name: `Weight (${MEASURE_UNITS_BY_SYSTEM[values?.measurement][MEASUREMENT_UNITS.lengthPerWeight]})`,
      type: 'weight',
      designation: 'liquidMarking'
    },
    {
      name: `Each (${MEASURE_UNITS_BY_SYSTEM[values?.measurement][MEASUREMENT_UNITS.length]}, `
      + `${MEASURE_UNITS_BY_SYSTEM[values?.measurement][MEASUREMENT_UNITS.area]} and EA)`,
      type: 'eradication',
      designation: 'eradication'
    },
    { name: 'Each', type: 'each', designation: 'liquidMarking' },
  ]), [values?.measurement]);

  useEffect(() => {
    setFieldValue('type', unitType);
  }, [unitType])

  const onHomepageStatsChange = (e) => {
    if (e.target.value === values.homepageStatistic) return;
    
    setFieldValue('homepageStatistic', e.target.value);
    
    if (e.target.value === 'eradication') setUnitType('eradication');
    else if (e.target.value === data.homepageStatistic) setUnitType(data.type);
    else setUnitType(null);
  }

  return (
    <Grid container spacing={1} style={{ justifyContent: 'space-between', marginBottom: '10px' }}>
      <Grid item xs={12} lg={6}>
        <label htmlFor="homepageStatistic">
          <Typography variant="body1" color="textSecondary">
            Designation:
          </Typography>
          <TextField
            select
            id="homepageStatistic"
            name="homepageStatistic"
            error={Boolean(errors.homepageStatistic)}
            variant="outlined"
            InputProps={{
              className: `${errors.homepageStatistic ? 'materials-input--error' : ''}`,
              style: {
                  height: '35px',
                },
            }}
            fullWidth
            onChange={onHomepageStatsChange}
            onBlur={onHomepageStatsChange}
            defaultValue={values.homepageStatistic}
            SelectProps={{
              native: isIOS,
            }}
          >
            {homepageStatisticOptions.map((s) => (
              <Option key={s.type} value={s.type}>
                {s.name}
              </Option>
            ))}
          </TextField>
        </label>
        {errors.homepageStatistic && <span className="materials-input--error-text">Field is required</span>}
      </Grid>
      <Grid item xs={12} lg={6}>
        <label htmlFor="type">
          <Typography variant="body1" color="textSecondary">
            Unit of Measurement:
          </Typography>
          <TextField
            select
            id="type"
            name="type"
            error={Boolean(touched.type && errors.type)}
            variant="outlined"
            InputProps={{
              className: `${(touched.type && errors.type) ? 'materials-input--error' : ''}`,
              style: {
                  height: '35px',
                },
            }}
            fullWidth
            onChange={(e) => setUnitType(e.target.value)}
            onBlur={handleBlur}
            value={values.type || ''}
            SelectProps={{
              native: isIOS,
            }}
          >
            {materials.filter(({ designation }) => designation === values.homepageStatistic || !values.homepageStatistic).map((m) => (
              <Option key={m.type} value={m.type}>
                {m.name}
              </Option>
            ))}
          </TextField>
        </label>
        {touched.type && errors.type && <span className="materials-input--error-text">Field is required</span>}
      </Grid>
      <Grid item xs={12} lg={6}>
        <label htmlFor="decimalPlaces">
          <Typography variant="body1" color="textSecondary">
            Number of Decimal Places:
          </Typography>
          <TextField
            id="decimalPlaces"
            name="decimalPlaces"
            type="number"
            variant="outlined"
            className="materials-input"
            error={Boolean(errors.decimalPlaces)}
            onChange={handleChange}
            onBlur={handleBlur}
            InputProps={{
              className: `${errors.decimalPlaces ? 'materials-input--error' : ''}`,
              inputProps: { min: 0, step: 1 },
            }}
            fullWidth
            value={values.decimalPlaces ?? 2}
          />
        </label>
        {errors.decimalPlaces && <span className="materials-input--error-text">{errors.decimalPlaces}</span>}
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(UnitsType);
